import { AllRoutes, MARKETING } from 'pricing-pages-lib/constants/PricingPageRoutes';
import { getAbsolutePricingPageUrl } from 'pricing-pages-lib/utils/urls';
import { getIsAcceptanceTest } from 'pricing-pages-ui/utils/testUtils';
import { getHostname, getPathname, getSearch, navigateTo } from './browserNav';

/**
 * Returns `true` when a redirect has been scheduled so the caller can skip
 * booting the rest of the app (avoids wasted renders/fetches before unload).
 */
export function redirectNonProxied() {
  const hostname = getHostname();
  const search = getSearch();
  const isOnApp = !!hostname.match(/^app(-.*)?\.hubspot(qa)?\.com/);
  const forceRedirect = new URLSearchParams(search).has('forceRedirect');
  if (!isOnApp || getIsAcceptanceTest() && !forceRedirect) {
    return false;
  }
  const isQA = hostname.indexOf('qa') >= 0;
  const productLine = getPathname().split('/').find(slug => slug && AllRoutes.includes(slug)) || MARKETING;
  const newUrl = `${getAbsolutePricingPageUrl({
    slug: productLine,
    isAppAuth: false,
    isQA
  })}${search}`;
  navigateTo(newUrl);
  return true;
}